import React from 'react';

export type DatevStatus = { enabled: boolean; configured: boolean; canManage: boolean };

const EMPTY: DatevStatus = { enabled: false, configured: false, canManage: false };

// Je Instanz zwischengespeichert (Instanzwechsel ändert den Pfad /i/:id/…).
const cache = new Map<string, DatevStatus>();
const inflight = new Map<string, Promise<DatevStatus>>();
const listeners = new Set<(status: DatevStatus) => void>();

function instanceKey(): string {
  return window.location.pathname.match(/^\/i\/([^/]+)/)?.[1] ?? 'default';
}

async function fetchStatus(): Promise<DatevStatus> {
  try {
    const res = await fetch('/api/datev/status', { credentials: 'include' });
    if (!res.ok) return EMPTY;
    const d = await res.json();
    return { enabled: Boolean(d?.enabled), configured: Boolean(d?.configured), canManage: Boolean(d?.canManage) };
  } catch {
    return EMPTY;
  }
}

/** Neu laden, z. B. nach dem Aktivieren in den Einstellungen. */
export function refreshDatevStatus(): Promise<DatevStatus> {
  const key = instanceKey();
  const request = fetchStatus().then((status) => {
    cache.set(key, status);
    inflight.delete(key);
    if (key === instanceKey()) for (const listener of listeners) listener(status);
    return status;
  });
  inflight.set(key, request);
  return request;
}

/**
 * Ist DATEV in dieser Instanz aktiv? Einmal geladen und geteilt. Solange unbekannt: nicht aktiv,
 * damit nichts DATEV-Spezifisches aufblitzt.
 */
export function useDatevStatus(): DatevStatus {
  const [status, setStatus] = React.useState<DatevStatus>(cache.get(instanceKey()) ?? EMPTY);
  React.useEffect(() => {
    listeners.add(setStatus);
    const key = instanceKey();
    const known = cache.get(key);
    if (known) setStatus(known);
    else void (inflight.get(key) ?? refreshDatevStatus());
    return () => {
      listeners.delete(setStatus);
    };
  }, []);
  return status;
}
